import { traceabilitiesTypes } from './actionTypes';

const INIT_STATE = {
  listData: [],
  error: {},
  success: '',
  CountItems: 0,
  filterItems: [],
  loading: false,
};

const Traceabilities = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case traceabilitiesTypes.GET_FILTER_LIST:
      state = { ...state, loading: true };
      break;
    case traceabilitiesTypes.GET_FILTERS:
      state = { ...state, loading: true };
      break;
    case traceabilitiesTypes.GET_FILTER_LIST_SUCCESS:
      return {
        ...state,
        listData: action.payload.listData,
        CountItems: action.payload.CountItems,
        loading: false,
      };
    case traceabilitiesTypes.GET_FILTERS_SUCCESS:
      return {
        ...state,
        filterItems: action.payload.filterItems,
        loading: false,
      };
    case traceabilitiesTypes.GET_FILTER_LIST_ERROR:
      state = {
        ...state,
        error: action.payload,
        listData: [],
        loading: false,
      };
      break;
    case traceabilitiesTypes.GET_FILTER_LIST_WRNUMBER:
      state = { ...state };
      break;
    case traceabilitiesTypes.GET_FILTER_LIST_SUCCESS_WRNUMBER:
      return {
        ...state,
        listData: action.payload.listData,
      };
    case traceabilitiesTypes.GET_FILTER_LIST_FAIL_WRNUMBER:
      state = {
        ...state,
        error: action.payload,
        listData: [],
      };
      break;
    default:
      break;
  }

  return state;
};

export default Traceabilities;
